import * as React from 'react'

import { observer } from 'mobx-react'
import { classList } from 'react-classlist-helper'

import * as Icons from '~/client/src/shared/components/Icons'
import Localization from '~/client/src/shared/localization/LocalizationManager'

import './GeoreferencingLabel.scss'

interface IProps {
  isReferenced: boolean
  className?: string
  isCompact?: boolean
}

@observer
export default class GeoreferencingLabel extends React.Component<IProps> {
  public render() {
    const { isReferenced, className, isCompact } = this.props

    return (
      <div
        className={classList({
          'row georeferencing-label': true,
          className: !!className,
          'x-between': !isCompact,
          'x-end': isCompact,
        })}
      >
        <div
          className={classList({
            'georeferenced-label no-grow row brada5 w-max-content': true,
            referenced: isReferenced,
            'not-referenced': !isReferenced,
          })}
        >
          {isReferenced ? (
            <Icons.Referenced className="no-grow geo-icon" />
          ) : (
            <Icons.NotReferenced className="no-grow geo-icon" />
          )}
          {!isCompact && (
            <span>
              {isReferenced
                ? Localization.translator.georeferenced
                : Localization.translator.nonGeoreferenced}
            </span>
          )}
        </div>
      </div>
    )
  }
}
